import { Image } from "react-native";
import { LogoProps } from "./Logo.types";

export default function Logo({ height, width, resizeMode }: LogoProps) {
  return (
    <Image
      source={require("../../../../assets/images/logo6.webp")}
      style={{ width: width || 100, height: height || 100 }}
      resizeMode={resizeMode || "cover"}
    />
  );
}
